export const formatAgentAvailability = (availability: string): string => {
  if (!availability || Object.keys(availability).length === 0) {
    return 'No data';
  }

  return Object.entries(availability)
    .map(([channel, count]) => `${channel}: ${count}`)
    .join(', ');
};
